export default __webpack_public_path__ + "static/media/ra-guitar-c.8ef764ca.svg";